import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailMask',
  standalone: false,
})
export class EmailMaskPipe implements PipeTransform {
  // transform(value: unknown, ...args: unknown[]): unknown {
  transform(value: string): string {
    if (!value || !value.includes('@')) return value;
    const [user, domain] = value.split('@');
    const maskedUser = user.slice(0, 3) + 'xxxx';
    const maskedDomain = domain.replace(/\..*$/, '.xxx');
    return `${maskedUser}[@]${maskedDomain}`;
  }
  // }
}
